import React from 'react';
import { Link } from 'react-router-dom';
import { trackSocialClick } from '../utils/analytics';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h3>Nicole Schweitzer</h3>
            <p>Professional children's fashion photography</p>
            <p>Capturing precious moments and beautiful memories</p>
          </div>
          
          <div className="footer-section">
            <h4>Quick Links</h4>
            <ul>
              <li><Link to="/">Home</Link></li>
              <li><Link to="/gallery">Gallery</Link></li>
              <li><Link to="/achievements">Achievements</Link></li>
              <li><Link to="/about">About</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </div>
          

          
          <div className="footer-section">
            <h4>Follow</h4>
            <div className="social-links">
              <a href="https://www.instagram.com/buzymomma4kidz" target="_blank" rel="noopener noreferrer" aria-label="Instagram" onClick={() => trackSocialClick('instagram')}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                </svg>
              </a>
              <a href="https://www.facebook.com/momma2connor/" target="_blank" rel="noopener noreferrer" aria-label="Facebook" onClick={() => trackSocialClick('facebook')}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                </svg>
              </a>
              <a href="https://www.threads.com/@buzymomma4kidz" target="_blank" rel="noopener noreferrer" aria-label="Threads" onClick={() => trackSocialClick('threads')}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12.186 24h-.007c-3.581-.024-6.334-1.205-8.184-3.509C2.35 18.44 1.5 15.586 1.5 12.002c0-3.584.85-6.438 2.495-8.489C5.845 1.209 8.598.028 12.179.004h.007c3.581.024 6.334 1.205 8.184 3.509C21.65 5.562 22.5 8.416 22.5 12.002c0 3.584-.85 6.438-2.495 8.489C18.155 22.791 15.402 23.972 11.821 23.996h-.007zM12.179 1.5c-3.302.022-5.814.987-7.436 2.794C3.5 5.847 2.75 8.714 2.75 12.002c0 3.288.75 6.155 1.993 8.708 1.622 1.807 4.134 2.772 7.436 2.794 3.302-.022 5.814-.987 7.436-2.794C20.5 18.153 21.25 15.286 21.25 12.002c0-3.288-.75-6.155-1.993-8.708C17.635 1.487 15.123.522 11.821.5h.358z"/>
                  <path d="M12.179 6.5c-2.302.015-4.064.732-5.186 2.151C5.5 10.347 5 12.502 5 15.002c0 2.5.5 4.655 1.493 6.351 1.122 1.419 2.884 2.136 5.186 2.151 2.302-.015 4.064-.732 5.186-2.151C17.5 19.657 18 17.502 18 15.002c0-2.5-.5-4.655-1.493-6.351C15.385 7.232 13.623 6.515 11.321 6.5h.858z"/>
                </svg>
              </a>

            </div>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p>&copy; {currentYear} Nicole Schweitzer Photography. All rights reserved.</p>
          <p>nicole.photos</p>
          <button 
            onClick={() => {
              localStorage.removeItem('pwa-install-dismissed');
              window.location.reload();
            }}
            style={{
              background: 'none',
              border: 'none',
              color: 'var(--text-muted)',
              fontSize: '12px',
              textDecoration: 'underline',
              cursor: 'pointer',
              padding: '0',
              margin: '0'
            }}
            title="Reset PWA install preference"
          >
            Reset install preference
          </button>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
